<mat-drawer-container autosize>
  <div class="base-container">
    <mat-tab-group
      mat-align-tabs="start"
      (selectedIndexChange)="onTabChange($event)">
      <!-- VIGILANCE -->
      <mat-tab label="Vigilance">
        <div class="vigilance-card-container">
          <mat-card
            appearance="outlined"
            (click)="goToLink('https://vigilance.meteofrance.fr/fr')"
            class="mat-card--logo">
            <img
              mat-card-image
              src="https://wm-custom-shared.s3.eu-west-1.amazonaws.com/vigilance/QGFR17_LFPW_.gif"
              alt="Image of MeteoFrance-Vigilance" />

            <div class="button-container">
              <button
                mat-mini-fab
                color="primary"
                aria-label="Example icon button with a delete icon">
                <fa-icon [icon]="['far', 'arrow-right']" size="lg"></fa-icon>
              </button>
            </div>
          </mat-card>
        </div>
      </mat-tab>

      <!-- MISE A JOUR 10:30 -->
      <mat-tab label="{{ 'PRODUCT.M6.UPDATE' | translate }} 10:30">
        @let forecastTextMAJ1030 = forecastTextMAJ1030$ | async;
        @if (forecastTextMAJ1030) {
          @for (data of forecastTextMAJ1030; track $index; let i = $index) {
            <app-m6-forecast
              [text]="data?.text"
              [date]="data?.['prescribe_at']"
              [imageUrl]="imageUrlsMAJ1030?.[i]"></app-m6-forecast>
          }
        } @else {
          <ng-container *ngTemplateOutlet="noForecastData"></ng-container>
        }
      </mat-tab>

      <!-- MISE A JOUR 11:30 -->
      <mat-tab label="{{ 'PRODUCT.M6.UPDATE' | translate }} 11:30">
        @let forecastTextMAJ1130 = forecastTextMAJ1130$ | async;
        @if (forecastTextMAJ1130) {
          <!-- FORECAST  -->
          @for (data of forecastTextMAJ1130; track $index; let i = $index) {
            <app-m6-forecast
              [text]="data?.text"
              [date]="data?.['prescribe_at']"
              [imageUrl]="forecastImageUrlsMAJ1130?.[i]"></app-m6-forecast>
          }
        } @else {
          <ng-container *ngTemplateOutlet="noForecastData"></ng-container>
        }

        @let trendTextMAJ1130 = trendTextMAJ1130$ | async;
        @if (trendTextMAJ1130) {
          <!-- TREND -->
          @for (data of trendTextMAJ1130; track $index; let i = $index) {
            <app-m6-forecast
              [id]="data?.id"
              [text]="data?.text"
              [imageUrl]="trendImageUrlsMAJ1130?.[i]"></app-m6-forecast>
          }
        } @else {
          <ng-container *ngTemplateOutlet="noForecastData"></ng-container>
        }
      </mat-tab>

      <!-- CYCLONE -->
      <mat-tab label="Cyclone">
        <div class="cyclone-card-container">
          <mat-card
            appearance="outlined"
            (click)="goToLink('https://www.nhc.noaa.gov/')"
            class="mat-card--logo">
            <img
              mat-card-image
              src="../../assets/images/M6/NOAA_logo.svg.png"
              alt="Logo of NOAA" />

            <div class="button-container">
              <button
                mat-mini-fab
                color="primary"
                aria-label="Example icon button with a delete icon">
                <fa-icon [icon]="['far', 'arrow-right']" size="lg"></fa-icon>
              </button>
            </div>
          </mat-card>

          <mat-card
            appearance="outlined"
            (click)="goToLink('https://meteofrance.re/fr/cyclone')"
            class="mat-card--logo">
            <img
              mat-card-image
              src="./../../assets/images/Logo_Météo_France.svg"
              alt="Logo of meteofrance" />

            <div class="button-container">
              <button
                mat-mini-fab
                color="primary"
                aria-label="Example icon button with a delete icon">
                <fa-icon [icon]="['far', 'arrow-right']" size="lg"></fa-icon>
              </button>
            </div>
          </mat-card>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</mat-drawer-container>

<ng-template #noForecastData>
  <mat-card appearance="outlined" class="m6-forecast-no-data-card">
    <fa-icon [icon]="['far', 'align-slash']" [size]="'4x'"></fa-icon>
    <p>{{ 'PRODUCT.M6.NO_DATA' | translate }}</p>
  </mat-card>
</ng-template>
